import {useOktaAuth} from '@okta/okta-react';

export const useAuth = () => {
  const {oktaAuth, authState} = useOktaAuth();

  return {
    authState,
    getUser: oktaAuth.getUser.bind(oktaAuth),
    setOriginalUri: oktaAuth.setOriginalUri.bind(oktaAuth),
    login: oktaAuth.signInWithRedirect.bind(oktaAuth),
    logout: oktaAuth.signOut.bind(oktaAuth),
  };
};
